export const productSkeletonStyles = {
  grid: {
    maxWidth: "90rem",
    px: {
      mobile: "1.5rem",
      tablet: "unset",
    },
    alignItems: "left",
    justifyContent: "center",
    margin: {
      tablet: "auto 0",
      laptop: "5rem auto 10rem",
    },
  },
  card: {
    alignItems: "center",
    height: {
      mobile: "29.875rem",
      tablet: "19.375rem",
      laptop: "29.875rem",
    },
    mx: {
      tablet: "2.5rem",
    },
    width: {
      mobile: "100%",
      laptop: "18.875rem",
    },
  },
  image: {
    height: {
      mobile: "20rem",
      tablet: "19.375rem",
      desktop: "20rem",
    },
    width: {
      mobile: "100%",
      tablet: "21.875rem",
    },
  },
  cardStack: {
    alignItems: "center",
  },
  title: {
    width: {
      mobile: "50vw",
      tablet: "20vw",
      laptop: "12.875rem",
    },
    height: "2rem",
  },
  cardContent: {
    mt: "1.25rem",
  },
  content: {
    width: {
      mobile: "70vw",
      tablet: "40vw",
      laptop: "17.875rem",
    },
    height: "1rem",
  },
};
